import { useCallback, useEffect, useMemo, useState } from 'react'

import { useWindowLocationHash } from './use-window-location-hash.ts'

/**
 *
 * @param dialogId A unique identifier to identify the relevant dialog and avoid dialog confusion.
 */
export function useDialogVisibility(dialogId: string): { visible: boolean; show: () => void; hide: () => void } {
  const dialogHash = `dialog-${dialogId}`
  const { hash, updateHash } = useWindowLocationHash()

  const [visible, setVisible] = useState(hash === dialogHash)

  const show = useCallback(() => {
    updateHash(dialogHash)
  }, [dialogHash, updateHash])

  const hide = useCallback(() => {
    updateHash('')
  }, [updateHash])

  useEffect(() => {
    // Deriving `visible` from `hash` instead of syncing it here has been tried and regressed, so the
    // effect stays.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setVisible(hash === dialogHash)
  }, [hash, dialogHash])

  return useMemo(() => ({ visible, show, hide }), [visible, show, hide])
}
